module.exports = __webpack_public_path__ + "img/img_64703_0_0.1d289b89.png";